module.exports = __webpack_public_path__ + "img/DeleteActionGrey.27557624.svg";